import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { z } from "zod";
import { ZodExtended } from "@/data/zod.extended";
import { NotificationsModels } from "./notifications.models";

export namespace NotificationsApi {
export const getUser = (limit: number, order?: string, filter?: NotificationsModels.NotificationFilterDto, page?: number, cursor?: string, ) => { 
    return AppRestClient.get( 
        { resSchema: NotificationsModels.PaginatedNotificationResponseDtoSchema }, 
        `/notifications`,
        {
    params: {
        order: ZodExtended.parse(z.string().nullish(), order, { type: "query", name: "order" })
, 
        filter: ZodExtended.parse(NotificationsModels.NotificationFilterDtoSchema.optional(), filter, { type: "query", name: "filter" })
, 
        limit: ZodExtended.parse(z.number().gte(1).lte(100).default(10), limit, { type: "query", name: "limit" })
, 
        page: ZodExtended.parse(z.number().nullish(), page, { type: "query", name: "page" })
, 
        cursor: ZodExtended.parse(z.string().nullish(), cursor, { type: "query", name: "cursor" })
, 
    },
}
    )
};

export const deleteAll = () => { 
    return AppRestClient.delete( 
        { resSchema: z.void() }, 
        `/notifications`,
        
    )
};

export const getUnread = () => { 
    return AppRestClient.get( 
        { resSchema: NotificationsModels.GetUnreadResponseSchema }, 
        `/notifications/unread`,
        
    )
};

export const markAsRead = (id: string, ) => { 
    return AppRestClient.patch( 
        { resSchema: NotificationsModels.NotificationDtoSchema }, 
        `/notifications/${id}/read`,
        
    )
};

export const markAllAsRead = () => { 
    return AppRestClient.patch( 
        { resSchema: z.void() }, 
        `/notifications/read-all`,
        
    )
};

export const deleteNotification = (id: string, ) => { 
    return AppRestClient.delete( 
        { resSchema: z.void() }, 
        `/notifications/${id}`,
        
    )
};

}
